import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";

const customPreset = definePreset(Lara, {
  semantic: {
    colorScheme: {
      light: {

        surface: {
          0: "#ffffff",
          50: "var(--basic-50)",
          100: "var(--basic-100)",
          200: "var(--basic-200)",
          300: "var(--basic-300)",
          400: "var(--basic-400)",
          500: "var(--basic-500)",
          600: "var(--basic-600)",
          700: "var(--basic-700)",
          800: "var(--basic-800)",
          900: "var(--basic-900)",
          950: "var(--basic-950)",
          contrastColor: "var(--text-control-basic-color)",
        },
        primary: {
          50: "var(--primary-50)",
          100: "var(--primary-100)",
          200: "var(--primary-200)",
          300: "var(--primary-300)",
          400: "var(--primary-400)",
          500: "var(--primary-500)",
          600: "var(--primary-600)",
          700: "var(--primary-700)",
          800: "var(--primary-800)",
          900: "var(--primary-900)",
          950: "var(--primary-950)",
          contrastColor: "var(--primary-contrast)",
        },

        secondary: {
          50: "var(--secondary-50)",
          100: "var(--secondary-100)",
          200: "var(--secondary-200)",
          300: "var(--secondary-300)",
          400: "var(--secondary-400)",
          500: "var(--secondary-500)",
          600: "var(--secondary-600)",
          700: "var(--secondary-700)",
          800: "var(--secondary-800)",
          900: "var(--secondary-900)",
          950: "var(--secondary-950)",
          contrastColor: "var(--secondary-contrast)",
        },

        info: {
          50: "var(--info-50)",
          100: "var(--info-100)",
          200: "var(--info-200)",
          300: "var(--info-300)",
          400: "var(--info-400)",
          500: "var(--info-500)",
          600: "var(--info-600)",
          700: "var(--info-700)",
          800: "var(--info-800)",
          900: "var(--info-900)",
          950: "var(--info-950)",
          contrastColor: "var(--info-contrast)",
        },

        success: {
          50: "var(--success-50)",
          100: "var(--success-100)",
          200: "var(--success-200)",
          300: "var(--success-300)",
          400: "var(--success-400)",
          500: "var(--success-500)",
          600: "var(--success-600)",
          700: "var(--success-700)",
          800: "var(--success-800)",
          900: "var(--success-900)",
          950: "var(--success-950)",
          contrastColor: "var(--success-contrast)",
        },

        warn: {
          50: "var(--warn-50)",
          100: "var(--warn-100)",
          200: "var(--warn-200)",
          300: "var(--warn-300)",
          400: "var(--warn-400)",
          500: "var(--warn-500)",
          600: "var(--warn-600)",
          700: "var(--warn-700)",
          800: "var(--warn-800)",
          900: "var(--warn-900)",
          950: "var(--warn-950)",
          contrastColor: "var(--warn-contrast)",
        },
        help: {
          50: "var(--help-50)",
          100: "var(--help-100)",
          200: "var(--help-200)",
          300: "var(--help-300)",
          400: "var(--help-400)",
          500: "var(--help-500)",
          600: "var(--help-600)",
          700: "var(--help-700)",
          800: "var(--help-800)",
          900: "var(--help-900)",
          950: "var(--help-950)",
          contrastColor: "var(--help-contrast)",
        }
      },
      dark: {
        surface: {
          0: "#ffffff",
          50: "var(--basic-0)",
          100: "var(--basic-100)",
          200: "var(--basic-200)",
          300: "var(--basic-300)",
          400: "var(--basic-400)",
          500: "var(--basic-500)",
          600: "var(--basic-600)",
          700: "var(--basic-700)",
          800: "var(--basic-800)",
          900: "var(--basic-900)",
          950: "var(--basic-950)",
          contrastColor: "var(--basic-contrast)",
        },
        primary: {
          50: "var(--primary-50)",
          100: "var(--primary-100)",
          200: "var(--primary-200)",
          300: "var(--primary-300)",
          400: "var(--primary-400)",
          500: "var(--primary-500)",
          600: "var(--primary-600)",
          700: "var(--primary-700)",
          800: "var(--primary-800)",
          900: "var(--primary-900)",
          950: "var(--primary-950)",
          contrastColor: "var(--primary-contrast)",
        },

        secondary: {
          50: "var(--secondary-50)",
          100: "var(--secondary-100)",
          200: "var(--secondary-200)",
          300: "var(--secondary-300)",
          400: "var(--secondary-400)",
          500: "var(--secondary-500)",
          600: "var(--secondary-600)",
          700: "var(--secondary-700)",
          800: "var(--secondary-800)",
          900: "var(--secondary-900)",
          950: "var(--secondary-950)",
          contrastColor: "var(--secondary-contrast)",
        },
        success: {
          50: "var(--success-50)",
          100: "var(--success-100)",
          200: "var(--success-200)",
          300: "var(--success-300)",
          400: "var(--success-400)",
          500: "var(--success-500)",
          600: "var(--success-600)",
          700: "var(--success-700)",
          800: "var(--success-800)",
          900: "var(--success-900)",
          950: "var(--success-950)",
          contrastColor: "var(--success-contrast)",
        },
        info: {
          50: "var(--info-50)",
          100: "var(--info-100)",
          200: "var(--info-200)",
          300: "var(--info-300)",
          400: "var(--info-400)",
          500: "var(--info-500)",
          600: "var(--info-600)",
          700: "var(--info-700)",
          800: "var(--info-800)",
          900: "var(--info-900)",
          950: "var(--info-950)",
          contrastColor: "var(--info-contrast)",
        },
        warn: {
          50: "var(--warn-50)",
          100: "var(--warn-100)",
          200: "var(--warn-200)",
          300: "var(--warn-300)",
          400: "var(--warn-400)",
          500: "var(--warn-500)",
          600: "var(--warn-600)",
          700: "var(--warn-700)",
          800: "var(--warn-800)",
          900: "var(--warn-900)",
          950: "var(--warn-950)",
          contrastColor: "var(--warn-contrast)",
        },
        help: {
          50: "var(--help-50)",
          100: "var(--help-100)",
          200: "var(--help-200)",
          300: "var(--help-300)",
          400: "var(--help-400)",
          500: "var(--help-500)",
          600: "var(--help-600)",
          700: "var(--help-700)",
          800: "var(--help-800)",
          900: "var(--help-900)",
          950: "var(--help-950)",
          contrastColor: "var(--help-contrast)",
        }
      },
    },
  },
  components: {
    inputgroup: {
      colorScheme: {
        light: {
          addon: {
            background: "{surface.0}"
          }
        },
        dark: {
          addon: {
            background: "{surface.950}"
          }
        }
      }
    },
    checkbox: {
      root: {
        borderRadius: "100%"
      }
    },
    radiobutton: {
      icon: {
        checkedColor: "{primary.500}",
      }
    },
    tabs: {
      tab: {
        activeBorderColor: "var(--layout-text-color)",
        color: "{text.muted.color}",
        hoverColor: "{text.color}",
        activeColor: "{primary.contrastColor}",
      },
      colorScheme: {
        light: {
          tab: {
            background: "{surface.50}",
            hoverBackground: "{surface.100}",
            activeBackground: "{primary.500}"
          }
        },
        dark: {
          tab: {
            background: "{surface.800}",
            hoverBackground: "{surface.700}",
            activeBackground: "{primary.500}"
          }
        }
      }
    
    },
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: "{primary.500}",
              hoverBackground: "{primary.600}",
              activeBackground: "{primary.700}",
              borderColor: "{primary.500}",
              hoverBorderColor: "{primary.600}",
              activeBorderColor: "{primary.700}",
              color: "{primary.contrastColor}",
              hoverColor: "{primary.contrastColor}",
              activeColor: "{primary.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {primary.200}"
              }
            },
            secondary: {
              background: "{secondary.500}",
              hoverBackground: "{secondary.600}",
              activeBackground: "{secondary.700}",
              borderColor: "{secondary.500}",
              hoverBorderColor: "{secondary.600}",
              activeBorderColor: "{secondary.700}",
              color: "{secondary.contrastColor}",
              hoverColor: "{secondary.contrastColor}",
              activeColor: "{secondary.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {secondary.200}"
              }
            },
            info: {
              background: "{info.500}",
              hoverBackground: "{info.600}",
              activeBackground: "{info.700}",
              borderColor: "var(--layout-border-color)",
              hoverBorderColor: "{info.600}",
              activeBorderColor: "{info.700}",
              color: "{info.contrastColor}",
              hoverColor: "{info.contrastColor}",
              activeColor: "{info.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {info.200}"
              }
            },
            success: {
              background: "{success.500}",
              hoverBackground: "{success.600}",
              activeBackground: "{success.700}",
              borderColor: "{success.500}",
              hoverBorderColor: "{success.600}",
              activeBorderColor: "{success.700}",
              color: "{success.contrastColor}",
              hoverColor: "{success.contrastColor}",
              activeColor: "{success.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {success.200}"
              }
            },
            warn: {
              background: "{warn.500}",
              hoverBackground: "{warn.600}",
              activeBackground: "{warn.700}",
              borderColor: "{warn.500}",
              hoverBorderColor: "{warn.600}",
              activeBorderColor: "{warn.700}",
              color: "{warn.contrastColor}",
              hoverColor: "{warn.contrastColor}",
              activeColor: "{warn.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {warn.200}"
              }
            },
            help: {
              background: "{help.500}",
              hoverBackground: "{help.600}",
              activeBackground: "{help.700}",
              borderColor: "{help.500}",
              hoverBorderColor: "{help.600}",
              activeBorderColor: "{help.700}",
              color: "{help.contrastColor}",
              hoverColor: "{help.contrastColor}",
              activeColor: "{help.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {help.200}"
              }
            },
            danger: {
              background: "{danger.500}",
              hoverBackground: "{danger.600}",
              activeBackground: "{danger.700}",
              borderColor: "{danger.500}",
              hoverBorderColor: "{danger.600}",
              activeBorderColor: "{danger.700}",
              color: "{danger.contrastColor}",
              hoverColor: "#ffffff",
              activeColor: "#ffffff",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {danger.200}"
              }
            }
          },
          outlined: {
            secondary: {
              hoverBackground: "{secondary.50}",
              activeBackground: "{secondary.100}",
              borderColor: "var(--layout-border-color)",
              color: "{secondary.500}"
            },
            success: {
              hoverBackground: "{success.50}",
              activeBackground: "{success.100}",
              borderColor: "{success.200}",
              color: "{success.500}"
            },
            info: {
              hoverBackground: "{info.50}",
              activeBackground: "{info.100}",
              borderColor: "var(--layout-border-color)",
              color: "{info.500}"
            },
            warn: {
              hoverBackground: "{warn.50}",
              activeBackground: "{warn.100}",
              borderColor: "{warn.200}",
              color: "{warn.500}"
            },
            help: {
              hoverBackground: "{help.50}",
              activeBackground: "{help.100}",
              borderColor: "{help.200}",
              color: "{help.500}"
            },
            danger: {
              hoverBackground: "{danger.50}",
              activeBackground: "{danger.100}",
              borderColor: "{danger.200}",
              color: "{danger.500}"
            },
            contrast: {
              borderColor: "var(--layout-border-color)",
            }
          },
          text: {
            secondary: {
              hoverBackground: "{secondary.100}",
              activeBackground: "{secondary.200}",
              color: "{secondary.600}"
            },
            success: {
              hoverBackground: "{success.50}",
              activeBackground: "{success.100}",
              color: "{success.500}"
            },
            info: {
              hoverBackground: "{info.50}",
              activeBackground: "{info.100}",
              color: "{info.500}"
            },
            warn: {
              hoverBackground: "{warn.50}",
              activeBackground: "{warn.100}",
              color: "{warn.500}"
            },
            help: {
              hoverBackground: "{help.50}",
              activeBackground: "{help.100}",
              color: "{help.500}"
            },
            danger: {
              hoverBackground: "{danger.50}",
              activeBackground: "{danger.100}",
              color: "{danger.500}"
            }
          },
          link: {
            color: "var(--layout-link-text-color)",
            hoverColor: "var(--layout-link-text-color)",
            activeColor: "var(--layout-link-text-color)"
          }
        },
        dark: {
          root: {
            primary: {
              background: "{primary.500}",
              hoverBackground: "{primary.600}",
              activeBackground: "{primary.700}",
              borderColor: "{primary.500}",
              hoverBorderColor: "{primary.600}",
              activeBorderColor: "{primary.700}",
              color: "{primary.contrastColor}",
              hoverColor: "{primary.contrastColor}",
              activeColor: "{primary.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {primary.200}"
              }
            },
            secondary: {
              background: "{secondary.500}",
              hoverBackground: "{secondary.600}",
              activeBackground: "{secondary.700}",
              borderColor: "{secondary.500}",
              hoverBorderColor: "{secondary.600}",
              activeBorderColor: "{secondary.700}",
              color: "{secondary.contrastColor}",
              hoverColor: "{secondary.contrastColor}",
              activeColor: "{secondary.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {secondary.200}"
              }
            },
            info: {
              background: "{info.500}",
              hoverBackground: "{info.600}",
              activeBackground: "{info.700}",
              borderColor: "var(--layout-border-color)",
              hoverBorderColor: "{info.600}",
              activeBorderColor: "{info.700}",
              color: "{info.contrastColor}",
              hoverColor: "{info.contrastColor}",
              activeColor: "{info.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {info.200}"
              }
            },
            success: {
              background: "{success.500}",
              hoverBackground: "{success.600}",
              activeBackground: "{success.700}",
              borderColor: "{success.500}",
              hoverBorderColor: "{success.600}",
              activeBorderColor: "{success.700}",
              color: "{success.contrastColor}",
              hoverColor: "{success.contrastColor}",
              activeColor: "{success.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {success.200}"
              }
            },
            warn: {
              background: "{warn.500}",
              hoverBackground: "{warn.600}",
              activeBackground: "{warn.700}",
              borderColor: "{warn.500}",
              hoverBorderColor: "{warn.600}",
              activeBorderColor: "{warn.700}",
              color: "{warn.contrastColor}",
              hoverColor: "{warn.contrastColor}",
              activeColor: "{warn.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {warn.200}"
              }
            },
            help: {
              background: "{help.500}",
              hoverBackground: "{help.600}",
              activeBackground: "{help.700}",
              borderColor: "{help.500}",
              hoverBorderColor: "{help.600}",
              activeBorderColor: "{help.700}",
              color: "{help.contrastColor}",
              hoverColor: "{help.contrastColor}",
              activeColor: "{help.contrastColor}",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {help.200}"
              }
            },
            danger: {
              background: "{danger.500}",
              hoverBackground: "{danger.600}",
              activeBackground: "{danger.700}",
              borderColor: "{danger.500}",
              hoverBorderColor: "{danger.600}",
              activeBorderColor: "{danger.700}",
              color: "{danger.contrastColor}",
              hoverColor: "#ffffff",
              activeColor: "#ffffff",
              focusRing: {
                color: "transparent",
                shadow: "0 0 0 0.2rem {danger.200}"
              }
            }
          },
          outlined: {
            secondary: {
              hoverBackground: "{secondary.50}",
              activeBackground: "{secondary.100}",
              borderColor: "var(--layout-border-color)",
              color: "{secondary.500}"
            },
            success: {
              hoverBackground: "{success.50}",
              activeBackground: "{success.100}",
              borderColor: "{success.200}",
              color: "{success.500}"
            },
            info: {
              hoverBackground: "{info.50}",
              activeBackground: "{info.100}",
              borderColor: "var(--layout-border-color)",
              color: "{info.500}"
            },
            warn: {
              hoverBackground: "{warn.50}",
              activeBackground: "{warn.100}",
              borderColor: "{warn.200}",
              color: "{warn.500}"
            },
            help: {
              hoverBackground: "{help.50}",
              activeBackground: "{help.100}",
              borderColor: "{help.200}",
              color: "{help.500}"
            },
            danger: {
              hoverBackground: "{danger.50}",
              activeBackground: "{danger.100}",
              borderColor: "{danger.200}",
              color: "{danger.500}"
            },
            contrast: {
              borderColor: "{surface.600}",
            }
          },
          text: {
            secondary: {
              hoverBackground: "{secondary.100}",
              activeBackground: "{secondary.200}",
              color: "{secondary.600}"
            },
            success: {
              hoverBackground: "{success.50}",
              activeBackground: "{success.100}",
              color: "{success.500}"
            },
            info: {
              hoverBackground: "{info.50}",
              activeBackground: "{info.100}",
              color: "{info.500}"
            },
            warn: {
              hoverBackground: "{warn.50}",
              activeBackground: "{warn.100}",
              color: "{warn.500}"
            },
            help: {
              hoverBackground: "{help.50}",
              activeBackground: "{help.100}",
              color: "{help.500}"
            },
            danger: {
              hoverBackground: "{danger.50}",
              activeBackground: "{danger.100}",
              color: "{danger.500}"
            }
          },
          link: {
            color: "var(--layout-link-text-color)",
            hoverColor: "var(--layout-link-text-color)",
            activeColor: "var(--layout-link-text-color)"
          }
        }
      }
    }
  }
});

export default customPreset;
